module.exports = __webpack_public_path__ + "static/media/work-banko.2a92f801.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/work-banko.jpg
// module id = 219
// module chunks = 0